import orderBy from 'lodash/orderBy';
import uniqBy from 'lodash/uniqBy';

interface CleanUserLayersInput {
    layerTypes: {[uniqueTilecacheKey: string]: LayerType} | undefined;
    isLayered: boolean;
    userLayers: UserLayer[] | undefined;
    defaultUserLayers: UserLayer[] | undefined;
}

export default function cleanUserLayers({
    layerTypes,
    isLayered,
    userLayers,
    defaultUserLayers,
}: CleanUserLayersInput) {
    if (!defaultUserLayers || !layerTypes || !userLayers) return;
    userLayers = uniqBy(userLayers, 'layer.type');

    // Ensure there is at least one selected layer
    if (userLayers.length === 0) {
        userLayers = defaultUserLayers.slice(0, 1);
    }

    // Ensure there is at least one visible layer
    if (!userLayers.find(({isVisible}) => isVisible)) {
        userLayers = uniqBy(
            [defaultUserLayers.find(({isVisible}) => isVisible)!, ...userLayers],
            'layer.type'
        );
    }

    // Preserve visual ordering when switching between isLayered settings
    if (isLayered === true) {
        userLayers = orderBy(userLayers, 'isVisible');
    }

    return userLayers;
}
